import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbProducts } from '../../types/pbBlocks';
import { getAdvanced, parseStyleString } from '../utils';

export type ProductsType = ContentTypeObject & PbProducts;

/**
 * Aggregates the configuration of a products element.
 * @param node
 * @param props
 */
export function productsConfigAggregator(node: CustomHtmlElement, props: any): ProductsType {
    const forms = node.querySelectorAll('[data-product-sku]');
    const skuArray = forms.map((form) => form.attributes['data-product-sku']);

    let carouselConfig = {};

    if (props.appearance === 'carousel') {
        carouselConfig = {
            showArrows: node.attributes['data-show-arrows'] === 'true',
            autoplay: node.attributes['data-autoplay'] === 'true',
            autoplaySpeed: parseInt(node.attributes['data-autoplay-speed']),
            carouselMode: node.attributes['data-carousel-mode'],
            centerPadding: node.attributes['data-center-padding'],
            showDots: node.attributes['data-show-dots'] === 'true',
            infinite: node.attributes['data-infinite-loop'] === 'true',
        };
    }

    const style = parseStyleString(node.attributes.style);

    return {
        ...getAdvanced(node, style),
        ...carouselConfig,
        skuArray,
        uniqueID: node.attributes['data-pb-style'],
    };
}
